// Both dashboards consume the same final-submission metadata from /sessions.
// Navigation and report-review milestones intentionally have no role here.
export const getClientPhaseProgress = (session) => {
  const completed = [1, 2, 3, 4].map(
    phase => session?.phase_completion?.[`phase${phase}`] === true
  );
  const count = completed.filter(Boolean).length;
  return { completed, count, allComplete: count === 4 };
};
